// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"708":"component---src-pages-404-js","736":"component---src-templates-blog-post-js","936":"component---src-pages-index-js"}[chunkId] + "-" + {"708":"7277019698e2a0a19f09","736":"037c0f3c10169bffe90d","936":"da7edb7aa33f361d2b6d"}[chunkId] + ".js";
};